import { render, staticRenderFns } from "./doc_yuyue.vue?vue&type=template&id=528db9ba&scoped=true"
import script from "./doc_yuyue.vue?vue&type=script&lang=js"
export * from "./doc_yuyue.vue?vue&type=script&lang=js"
import style0 from "./doc_yuyue.vue?vue&type=style&index=0&id=528db9ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528db9ba",
  null
  
)

export default component.exports